const Reports = () => {
  return (
    <>
      <div className="row">
        <div className="col-xl-4">
          Col 1
        </div>
        <div className="col-xl-8">
          Col 2
        </div>
      </div>
    </>
  )
}

export default Reports
